import {
  type ReportConfigData,
  type ReportConfigUpdateInput,
  type ReportConfigUpdateSuccess,
  toResponseError,
} from '@terros/common'
import { type UpdateHookResponse, mutationUpdate } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useReportConfigCache } from './cache'

export function useUpdateReportConfig(): UpdateHookResponse<ReportConfigData> {
  const cache = useReportConfigCache()

  const mutation = useTantalimMutation<ReportConfigUpdateInput, ReportConfigUpdateSuccess>({
    url: '/report/config/update',
  })

  async function update(reportConfig: ReportConfigData): Promise<ReportConfigData> {
    try {
      const { reportConfig: updated } = await mutation.mutateAsync({ reportConfig })
      cache.updateItem(updated)
      return updated
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
